import { SummaryItemDto, SummaryItemModel } from 'api/dto/new/SummaryCompared/SummaryItem.dto';
import {
  QuestionItemDto,
  QuestionItemModel,
} from 'api/dto/new/SummaryCompared/Questions/QuestionItem.dto';
import { RespondentProtectionEnumNullable } from 'model/RespondentProtection';
import { SimpleProject } from 'model/SimpleProject';
import { simpleProjectMapper } from 'container/simpleProjectMapper';
import { SimpleProjectApi } from 'api/SimpleProjectApi';

export type SummaryPulseOnDemandComparedDto = {
  combineModeLock: boolean;
  groups: Record<string, string>;
  protections: Record<string, RespondentProtectionEnumNullable>;
  summary: ReadonlyArray<SummaryItemDto>;
  questions: ReadonlyArray<QuestionItemDto>;
};

export type SummaryPulseOnDemandComparedModel = {
  combineModeLock: boolean;
  groups: Record<string, string>;
  protections: Record<string, RespondentProtectionEnumNullable>;
  summary: ReadonlyArray<SummaryItemModel>;
  questions: ReadonlyArray<QuestionItemModel>;
};

export const mapSummaryPulseOnDemandComparedDtoToSimpleProjectCompare = (
  dto: SummaryPulseOnDemandComparedDto
): SimpleProject.Compare => {
  // Temporal solution to quickly switch to new API
  return simpleProjectMapper.deserializeCompare((dto as unknown) as SimpleProjectApi.EntryCompare);
};

// TODO: use this mapper later for new endpoint proper typing - https://buzzing.atlassian.net/browse/RPT-258
// export const mapSummaryPulseOnDemandComparedDtoToModel = (
//   dto: SummaryPulseOnDemandComparedDto
// ): SummaryPulseOnDemandComparedModel => ({
//   combineModeLock: dto.combineModeLock,
//   groups: dto.groups,
//   protections: dto.protections,
//   summary: dto.summary,
//   questions: dto.questions.map(mapQuestionItemDtoToModel),
// });
